export enum AddOnFrequencyModel {
    LAST_NIGHT = "Last Night",
    FIRST_NIGHT = "first Night",
    DAILY = "Daily",
}